import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

const LargeVehicleIcon = ({
  color,
  heading = 0,
  onBreak = false,
  animateHeading = true,
}) => {
  // eslint-disable-next-line max-len
  const borderPath = 'M15,37.5 C23.0081289,37.5 29.5,31.0081289 29.5,23 C29.5,14.9918711 23.0081289,0.5 15,0.5 C6.99187113,0.5 0.5,14.9918711 0.5,23 C0.5,31.0081289 6.99187113,37.5 15,37.5 Z';

  // eslint-disable-next-line max-len
  const busPath = 'M3,12 C3,12.66 3.2925,13.2525 3.75,13.665 L3.75,15 C3.75,15.4125 4.0875,15.75 4.5,15.75 L5.25,15.75 C5.6625,15.75 6,15.4125 6,15 L6,14.25 L12,14.25 L12,15 C12,15.4125 12.3375,15.75 12.75,15.75 L13.5,15.75 C13.9125,15.75 14.25,15.4125 14.25,15 L14.25,13.665 C14.7075,13.2525 15,12.66 15,12 L15,4.5 C15,1.875 12.315,1.5 9,1.5 C5.685,1.5 3,1.875 3,4.5 L3,12 Z M5.625,12.75 C5.0025,12.75 4.5,12.2475 4.5,11.625 C4.5,11.0025 5.0025,10.5 5.625,10.5 C6.2475,10.5 6.75,11.0025 6.75,11.625 C6.75,12.2475 6.2475,12.75 5.625,12.75 Z M12.375,12.75 C11.7525,12.75 11.25,12.2475 11.25,11.625 C11.25,11.0025 11.7525,10.5 12.375,10.5 C12.9975,10.5 13.5,11.0025 13.5,11.625 C13.5,12.2475 12.9975,12.75 12.375,12.75 Z M13.5,8.25 L4.5,8.25 L4.5,4.5 L13.5,4.5 L13.5,8.25 Z';

  // eslint-disable-next-line max-len
  const pausePath = 'M6.75,12 L8.25,12 L8.25,6 L6.75,6 L6.75,12 Z M9,1.5 C4.86,1.5 1.5,4.86 1.5,9 C1.5,13.14 4.86,16.5 9,16.5 C13.14,16.5 16.5,13.14 16.5,9 C16.5,4.86 13.14,1.5 9,1.5 Z M9,15 C5.6925,15 3,12.3075 3,9 C3,5.6925 5.6925,3 9,3 C12.3075,3 15,5.6925 15,9 C15,12.3075 12.3075,15 9,15 Z M9.75,12 L11.25,12 L11.25,6 L9.75,6 L9.75,12 Z';

  const dropshadowId = _.uniqueId('dropshadow');
  const contrast = '#ffffff';

  return (
    <svg
      width="58px"
      height="58px"
      viewBox="-6 -6 58 58"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id={dropshadowId} y="-40%" height="180%" x="-40%" width="180%">
        <feOffset dx="1" dy="1" in="SourceAlpha" result="offset1" />
        <feGaussianBlur stdDeviation="2" in="offset1" result="blur1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          in="blur1"
          result="matrix1"
        />
        <feMerge>
          <feMergeNode in="matrix1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        style={{filter: `url(#${dropshadowId})`}}
      >
        <g
          style={{transition: animateHeading ? 'transform 6s ease' : 'transform 0s ease'}}
          transform={`translate(8.000000, 1.000000) rotate(${heading} 15 22)`}
        >
          <path d={borderPath} stroke={contrast} strokeWidth="3" fill={color} />
          <circle fill={contrast} cx="15" cy="8" r="3" />
        </g>
        <g transform={'translate(14, 14)'}>
          {onBreak ?
            (<g>
              <polygon points="0 0 18 0 18 18 0 18" />
              <path
                d={pausePath}
                fill="#FFFFFF"
                fillRule="nonzero"
              />
            </g>) : (<path d={busPath} fill={contrast} fillRule="nonzero" />)
          }
        </g>
      </g>
    </svg>
  );
};

LargeVehicleIcon.propTypes = {
  color: PropTypes.string.isRequired,
  heading: PropTypes.number,
  onBreak: PropTypes.bool,
  animateHeading: PropTypes.bool,
};

export default LargeVehicleIcon;



// WEBPACK FOOTER //
// ./src/common/components/VehicleOverlayMarker/LargeVehicleIcon.js